<select #comboBox
  [(ngModel)]="selectedClassCode" [disabled]="disabled" [hidden]="!visible"
  (change)="update($event);onChange($any($event.target).value);" (blur)="onTouched()"
  [style.width.px]="width" [style.width]="undefined !== width ? width : '100%'"
  [tabindex]="tabindex" [class.combo-box-required]="required" [autofocus]="autofocus">
  <ng-template ngFor let-item [ngForOf]="model.classList">
    <option value="{{item.ClassCode}}">{{item.ClassCodeName}}</option>
  </ng-template>
</select>
